import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    preferredFormat: { type: String, default: 'rgb' }
  }

  connect() {
    $(this.element).find("[data-spectrum-color]").spectrum({
      preferredFormat: this.preferredFormatValue,
      showAlpha: true,
      showInput: true,
    });
  }

  disconnect() {
    $(this.element).find("[data-spectrum-color]").spectrum("destroy");
  }
}
